import { render, staticRenderFns } from "./AggPolizaContableComponent.vue?vue&type=template&id=84c857b4&"
import script from "./AggPolizaContableComponent.vue?vue&type=script&lang=js&"
export * from "./AggPolizaContableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports